import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import HttpClient from '../../../utils/HttpClient';

const ViewComments = ({ strings, comment, setComment, metadata, setViewComments }) => {

    const editorRef = useRef(null);
    const HEADER = "<!DOCTYPE html><html><body>";
    const FOOTER = "</body></html>";



    const getTitle = () => metadata.Title?.value ?? metadata.Name?.value ?? metadata[strings['Filename']].value ?? "document";

    const saveLocalAndRestAPI = async () => {
        if (editorRef.current) {
            const documentTitle = getTitle();
            let content = editorRef.current.getContent();
            content = HEADER + content + FOOTER;
            console.log("content", content);
            const file = new File([content], `${documentTitle}_comment.html`, { type: 'text/html' });
            console.log("file", file);

            let date = new Date();
            const offset = date.getTimezoneOffset()
            date = new Date(date.getTime() - (offset * 60 * 1000))

            const meta = {
                type: "Comment",
                Titel: `${documentTitle}_comment`,
                Datum: date.toISOString().split('T')[0],
                isEditable: true,
            };
            const httpClient = new HttpClient();


            httpClient.upload(meta, file, comment.id)
                .then(result => {
                    if (!comment.id) {
                        setTimeout(() => {
                            httpClient.list("Comment", { Titel: `${documentTitle}_comment` }).then(data => {
                                const newCommentFile = data.find(d => result.id === d._id);
                                if (newCommentFile) {
                                    httpClient.link(metadata.Reference.value, newCommentFile.serialNo)
                                    setComment({ text: content, id: newCommentFile._id });
                                }
                                file.sent = true;
                            });
                        }, 1000);
                    } else {
                        setComment({ text: content, id: comment.id });
                    }
                    setViewComments(false);
                }).catch(error => {
                    console.log(JSON.stringify(error));
                    if (error.response && error.response.data && error.response.data.message) {
                        console.log(error.response.data.message);
                        alert(error.response.data.message);
                    }
                    else {
                        console.error("Failed to send file: " + error);
                        alert("Misslyckades att skicka");
                    }
                });
        }
    };

    const setContentOnInit = () => {
        setTimeout(() => {
            try {
                console.log("comment", comment);
                if (comment?.text) {
                    editorRef.current.setContent(comment.text);
                }
                else {
                    editorRef.current.setContent('<p></p>')
                }
            }
            catch (error) {
                editorRef.current.setContent('<p>Something unexpected happened with the editor. Please contact support.</p>')
                console.error("setContentOnInit error", error);
            }
        }, 0);
    }

    const getComments = () => {
        return (
            <div>
                <Editor tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
                    onInit={(evt, editor) => {
                        editorRef.current = editor;
                        setContentOnInit();
                    }
                    }
                    initialValue={'<p></<p>'}

                    init={{
                        selector: 'textarea',
                        height: 400,
                        menubar: false,
                        plugins: [
                            'advlist', 'save', 'autolink', 'lists', 'link', 'image', 'charmap',
                            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                            'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
                        ],
                        toolbar: 'undo redo | blocks | ' +
                            'bold italic forecolor | alignleft aligncenter ' +
                            'alignright alignjustify | bullist numlist outdent indent | ' +
                            'removeformat | help',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'

                    }}
                />
                <button onClick={saveLocalAndRestAPI}>Spara i TinyDS</button>
            </div>
        )
    }
    return getComments();
}

export default ViewComments;